import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  headerContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 4),
  },
  breadcrumb: {
    marginBottom: theme.spacing(1),
    '& a': {
      color: '#666',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      }
    },
    '& span': {
      color: '#333',
    }
  },
  pageTitle: {
    fontSize: '42px',
    fontWeight: 700,
    color: '#333',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
    },
  },
  pageDivider: {
    width: '80px',
    height: '4px',
    background: '#D60056',
    marginBottom: theme.spacing(4),
    borderRadius: '2px',
  },
  pageDescription: {
    fontSize: '18px',
    color: '#666',
    maxWidth: '700px',
    marginBottom: theme.spacing(4),
  }
}));

const PageHeader = ({ 
  title, 
  description,
  breadcrumbs = [] 
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.headerContainer}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Box className={classes.breadcrumb}>
          <Typography variant="body2">
            <Link to="/">Home</Link>
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                {' / '}
                {index === breadcrumbs.length - 1 ? (
                  <span>{crumb.label}</span>
                ) : (
                  <Link to={crumb.link || '#'}>{crumb.label}</Link>
                )}
              </React.Fragment>
            ))}
          </Typography>
        </Box>
      )}

      <Typography variant="h1" className={classes.pageTitle}>
        {title}
      </Typography>
      
      <div className={classes.pageDivider}></div>
      
      {description && (
        <Typography className={classes.pageDescription}>
          {description}
        </Typography>
      )}
    </Box>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string
    })
  ),
};

export default PageHeader;